<template>
  <div class="product-buy-fields">
    <p v-if="note.length" class="product-buy-fields_note">
      <template v-for="(line, index) in note" :key="index">
        {{ line }}<br v-if="index < note.length - 1" />
      </template>
    </p>
    <slot />
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `product-buy-fields`（購入枠の中のセレクト群の枠）。
 * 中身は `PartsProductBuyField` を1〜2個並べる。
 *
 * **支給は 31/38 にしか無いが、38本すべてに出す**（`KF01` `KF02` `KF03` `KF05` `KF15` `KG01` `KG02`
 * の7商品で欠けているのは支給漏れ。決定#43）。
 *
 * `note` は定期枠のみに出る説明文（「1回の配送でお届けする数量と、お届け間隔をご選択ください。
 * 数量に応じて割引価格が適用されます。」）。通常枠には無いので既定は空。
 * 行の配列で受ける（決定#56）。
 * → CONVERSION-GUIDE.md §3.3.1 の #6
 */
type Props = {
  /** 枠の上に出す説明。1要素＝1行 */
  note?: string[];
};

withDefaults(defineProps<Props>(), {
  note: () => [],
});
</script>
